import FormikContextInputField from '../../../../../../components/formikFileds/FormikContextInputField';
import {toEnglishDigits} from '../../../../../../utilities/helper/toEnglishNumber';

const LoanOwnerForm = () => {
  return (
    <div className="flex flex-col gap-2 text-gray-700">
      <span className="text-sm font-medium text-gray-900">اطلاعات فردی</span>
      <FormikContextInputField
        name={`global.address`}
        label="آدرس متقاضی اعتبار"
        placeholder="آدرس متقاضی اعتبار را وارد کنید"
        className="placeholder:text-sm "
        required
      />

      <FormikContextInputField
        name={`global.zip_code`}
        label="کد پستی متقاضی اعتبار"
        placeholder="کد پستی متقاضی اعتبار را وارد کنید"
        className="placeholder:text-sm"
        type="number"
        inputMode="numeric"
        onChangeFormatter={toEnglishDigits}
        maxLength={10}
        required
      />
    </div>
  );
};

export default LoanOwnerForm;
